import type { DynamicFormApi } from '../hooks/use-app-form';
import { DynamicFormField } from '../types';

export interface AddressFieldProps {
  form: DynamicFormApi;
  fieldInfo: DynamicFormField;
}

export const AddressField = ({ form, fieldInfo }: AddressFieldProps) => {
  return (
    <fieldset>
      <legend>
        <h2>Address Fields</h2>
      </legend>
      <form.AppField
        name={`${fieldInfo.key}.address1`}
        validators={{
          onChange: ({ value }) => {
            if (!value) return 'Address line 1 is required';
            return undefined;
          },
        }}
      >
        {(field) => (
          <field.FormField label='Address line 1' type='text' keepInlineLabel fieldKey={`${fieldInfo.key}.address1`} />
        )}
      </form.AppField>

      <form.AppField
        name={`${fieldInfo.key}.address2`}
        validators={{
          onChange: ({ value }) => {
            if (!value) return 'Address line 2 is required';
            return undefined;
          },
        }}
      >
        {(field) => (
          <field.FormField label='Address line 2' type='text' keepInlineLabel fieldKey={`${fieldInfo.key}.address2`} />
        )}
      </form.AppField>
    </fieldset>
  );
};
